module.exports = __webpack_public_path__ + "img/SAMPLE両面2.8354ab01.png";